import {
  deadlineTrafficColor,
  trafficColorToTone,
} from "./expediente-traffic-light.js";

const REMINDER_REFRESH_STATUSES = new Set([
  "waiting_for_details",
  "ai_processing",
  "ai_pending",
  "updating",
]);
const IMPORTANT_REMINDER_TONES = new Set(["danger", "warning"]);

export function isImportantReminderTone(tone) {
  return IMPORTANT_REMINDER_TONES.has(tone);
}

export function reminderRefreshPresentation({
  procedureState,
  procedureLoading = false,
  hasFallbackContent = false,
} = {}) {
  const hasSnapshot = Boolean(
    procedureState?.evaluation || hasFallbackContent,
  );
  const pending = Boolean(
    procedureLoading ||
    !procedureState ||
    REMINDER_REFRESH_STATUSES.has(procedureState?.status),
  );
  return {
    loading: pending && !hasSnapshot,
    updating: pending && hasSnapshot,
  };
}

export function reminderDashboardContentState({
  loading = false,
  updating = false,
  hasItems = false,
} = {}) {
  if (loading) return "loading";
  if (hasItems) return "items";
  if (updating) return "updating";
  return "empty";
}

export function selectDashboardImportantDeadlines(
  deadlines = [],
  representedPartyGroups = [],
  { now = new Date() } = {},
) {
  return deadlines
    .map((deadline) => ({
      ...deadline,
      dashboardTone: trafficColorToTone(
        deadlineTrafficColor(deadline, representedPartyGroups, { now }),
      ),
    }))
    .filter(({ dashboardTone }) =>
      isImportantReminderTone(dashboardTone))
    .sort((left, right) => {
      const toneOrder = { danger: 0, warning: 1 };
      const toneDifference =
        (toneOrder[left.dashboardTone] ?? 9) -
        (toneOrder[right.dashboardTone] ?? 9);
      if (toneDifference) return toneDifference;
      return String(left.dueDate || "").localeCompare(
        String(right.dueDate || ""),
      );
    });
}
